import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e4a8c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "pt5" }
const _hoisted_3 = { class: "link" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Q&A ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("| ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("質問板 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("| ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" メンバー ")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("| ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" チーム異常検知(β)")

import { computed } from 'vue'
import { Project } from '@/types/project'
import { ChatDotRound } from '@element-plus/icons';
import { useStore } from "vuex";
import { NoticeState } from "@/state/NoticeState";

interface Props {
  projects: Project[];
}
interface Emits {
  (e: "onClick"): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    projects: { type: Array, required: true }
  },
  emits: ["onClick"],
  setup(__props: any, { emit }: { emit: ({
  (e: "onClick"): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore();





const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const handleClick = (): void => emit('onClick')

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: __props.projects,
    "empty-text": "プロジェクトが作成されていません。"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, null, {
        default: _withCtx((scope) => [
          _createVNode(_component_router_link, {
            to: { name: 'TimeLines', params: { project_id: scope.row.id } },
            onClick: handleClick
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createTextVNode(_toDisplayString(scope.row.name) + " ", 1),
                  _createVNode(_component_el_badge, {
                    "is-dot": "",
                    class: "item",
                    hidden: _unref(NoticeState).get(scope.row.id).length == 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ChatDotRound))
                    ]),
                    _: 2
                  }, 1032, ["hidden"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ProjectQuestions', params: { project_id: scope.row.id } },
                    onClick: handleClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_5,
                  _createVNode(_component_router_link, {
                    to: { name: 'Posts', params: { project_id: scope.row.id } },
                    onClick: handleClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _hoisted_7,
                  _createVNode(_component_router_link, {
                    to: { name: 'ProjectUsers', params: { project_id: scope.row.id } },
                    onClick: handleClick
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (_unref(managerFlg))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_router_link, {
                          to: { name: 'ProjectAlertFormList', params: { project_id: scope.row.id } },
                          onClick: handleClick
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})